import React from 'react';
export const PerformanceSection = () => {
  // Updated performance data with the specified years and percentages
  const performanceData = [{
    year: '2025 (till date)',
    growth: 16.94,
    benchmark: 10.89
  }, {
    year: '2024',
    growth: 19.94,
    benchmark: 16.3
  }, {
    year: '2023',
    growth: 21.95,
    benchmark: 18.05
  }];
  return <section id="performance" className="py-16 bg-white" data-id="element-158">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        <div className="lg:text-center" data-id="element-160">
          <h2 className="text-base text-[#D4AF37] font-semibold tracking-wide uppercase" data-id="element-161">
            Our Track Record
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-800 sm:text-4xl" data-id="element-162">
            Performance History
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-600 lg:mx-auto" data-id="element-163">
            A consistent history of returns that have outperformed the Indian
            market benchmark.
          </p>
        </div>
        <div className="mt-16" data-id="element-164">
          <div className="overflow-x-auto" data-id="element-165">
            <table className="min-w-full divide-y divide-slate-200" data-id="element-166">
              <thead className="bg-slate-50" data-id="element-167">
                <tr data-id="element-168">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-169">
                    Year
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-170">
                    Aurum Grove Performance
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-171">
                    Nifty 50
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-172">
                    Outperformance
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-slate-200" data-id="element-173">
                {performanceData.map(item => <tr key={item.year} data-id="element-174">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900" data-id="element-175">
                      {item.year}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-700" data-id="element-176">
                      +{item.growth}%
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-700" data-id="element-177">
                      +{item.benchmark}%
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-[#D4AF37] font-medium" data-id="element-178">
                      +{(item.growth - item.benchmark).toFixed(1)}%
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <div className="mt-10 text-center" data-id="element-179">
            <p className="text-sm text-slate-500" data-id="element-180">
              Note: Past performance is not indicative of future results.
              Performance is benchmarked against the Nifty 50 Index. The above
              figures are for illustration purposes only.
            </p>
          </div>
        </div>
      </div>
    </section>;
};